import Link from 'next/link'
import clsx from 'clsx'
import { QRCodeSVG } from 'qrcode.react'
import { Container } from '@ui/components/Container'
import { ButtonAppStore, ButtonGooglePlay } from '@ui/components/buttons'

export const HeroDownload = ({
  downloadLink,
  className,
  children,
  title = 'Download the app',
  description = (
    <>
      Visit{' '}
      <Link className="text-blueberry-700 underline" href="/download">
        atm.com/download
      </Link>{' '}
      on your phone to download the app.
    </>
  ),
  hideQRCode = false,
  centered = false,
}: {
  downloadLink: string
  className?: string
  children?: React.ReactNode
  title?: React.ReactNode
  description?: React.ReactNode
  hideQRCode?: boolean
  centered?: boolean
}) => {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center py-4',
        className,
      )}
    >
      <Container>
        <div className={clsx(
          "flex flex-col items-center justify-center gap-8",
          !centered && "lg:flex-row"
        )}>
          <div className={clsx(
            "flex flex-col items-center justify-center gap-8",
            !centered && "lg:w-1/2 lg:items-start"
          )}>
            <h1 className={clsx(
              "font-primary h2 sm:h1 text-center",
              !centered && "lg:text-left"
            )}>
              {title}
            </h1>
            <div className="hidden flex-row items-start justify-center gap-4 md:flex">
              <ButtonAppStore downloadLink={downloadLink} />
              <ButtonGooglePlay downloadLink={downloadLink} />
            </div>
            <p className={clsx(
              "body-1 text-center",
              !centered && "lg:max-w-sm lg:text-left"
            )}>
              {description}
            </p>
            {!hideQRCode && (
              <div className="shadow-blueberry-900/20 hidden rounded-xl bg-white p-4 shadow-lg lg:block">
                <QRCodeSVG value={downloadLink} />
              </div>
            )}
          </div>
          {!centered && (
            <div className="flex flex-col items-start justify-center gap-4">
              {children}
            </div>
          )}
          <div className="flex flex-row items-center justify-center gap-2 md:hidden">
            <ButtonAppStore downloadLink={downloadLink} />
            <ButtonGooglePlay downloadLink={downloadLink} />
          </div>
        </div>
      </Container>
    </div>
  )
}
